import React from "react";
import styled from "styled-components";
import tw from "twin.macro";

const Content = styled.div`
  ${tw`flex flex-col gap-7 items-start p-[30px] md:p-[70px]`}
`;

const Logo = styled.div`
  width: 232px;

  @media (max-width: 950px) {
    width: 190px;
  }
`;

const Headline = styled.div``;

const Quote = styled.div`
  font-size: 32px;
  line-height: 46px;

  @media (max-width: 800px) {
    font-size: 28px;
    line-height: 42px;
  }

  @media (max-width: 600px) {
    font-size: 24px;
    line-height: 36px;
  }
`;

const Quotee = styled.div`
  ${tw`flex flex-row items-center gap-5`}

  img {
    ${tw`rounded-full`}
    width: 80px;
    height: 80px;
  }
`;

const QuoteeText = tw.div`flex flex-col`;

const QuoteeName = styled.div`
  ${tw`font-title`}
  font-size: 24px;
  font-weight: 500;
  line-height: 32px;

  @media (max-width: 600px) {
    font-size: 20px;
    line-height: 30px;
  }
`;

const JobTitle = styled.div`
  font-size: 21px;
  line-height: 32px;
`;

interface TestimonialLayoutStackedProps {
  logo: React.ReactElement;
  headline?: string;
  quote: React.ReactElement;
  headshot: React.ReactElement;
  name: string;
  jobTitle: string;
  extra?: React.ReactElement;
}

const TestimonialLayoutStacked: React.FunctionComponent<
  TestimonialLayoutStackedProps
> = ({ logo, headline, quote, headshot, name, jobTitle, extra }) => (
  <Content>
    <Logo>{logo}</Logo>
    {headline && <Headline>{headline}</Headline>}
    <Quote>{quote}</Quote>
    <Quotee>
      {headshot}
      <QuoteeText>
        <QuoteeName>{name}</QuoteeName>
        <JobTitle>{jobTitle}</JobTitle>
      </QuoteeText>
    </Quotee>
    {extra}
  </Content>
);

export default TestimonialLayoutStacked;
